import Marquee from "react-fast-marquee";
import { Seo } from "../components/Seo";
import { Reveal, MaskedLines } from "../components/Motion";
import { CtaBand } from "../components/CtaBand";
import { useLang } from "../i18n/LanguageContext";
import { CLIENTS, SITE_URL } from "../data/content";

export default function Portfolio() {
  const { t, data } = useLang();
  const p = t.portfolio;
  const schema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    url: `${SITE_URL}/portfolio`,
    name: "Portfolio — SG Language Services LLC",
    about: data.PORTFOLIO.map((item) => ({ "@type": "Thing", name: `${item.sector}: ${item.title}` }))
  };

  return (
    <>
      <Seo title={p.seoTitle} description={p.seoDesc} path="/portfolio" schema={schema} />
      <section className="max-w-7xl mx-auto px-6 lg:px-12 pt-16 lg:pt-24 pb-16 texture-grain" data-testid="portfolio-page">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-periwinkle-deep mb-6">{p.kicker}</p>
        <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl font-medium leading-[1.0] tracking-tight max-w-4xl">
          <MaskedLines lines={p.heroLines} />
        </h1>
        <p className="mt-8 text-muted2 leading-relaxed max-w-2xl">{p.intro}</p>
      </section>

      <div className="border-y border-ink/5 bg-white py-8">
        <Marquee speed={30} gradient gradientColor="#ffffff" gradientWidth={120} autoFill>
          {CLIENTS.map((c) => (
            <span key={c} className="mx-10 font-serif text-2xl text-ink/40 whitespace-nowrap italic">{c}</span>
          ))}
        </Marquee>
      </div>

      <section className="max-w-7xl mx-auto px-6 lg:px-12 py-20 lg:py-28 space-y-20">
        {data.PORTFOLIO.map((item, i) => (
          <Reveal key={item.sector}>
            <div className="grid lg:grid-cols-12 gap-12 items-center" data-testid={`portfolio-item-${i}`}>
              <div className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
                <div className="rounded-lg overflow-hidden border-8 border-white shadow-2xl shadow-periwinkle/15">
                  <img src={item.image} alt={item.title} className="w-full h-80 object-cover" />
                </div>
              </div>
              <div className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-1" : ""}`}>
                <p className="font-mono text-xs uppercase tracking-[0.3em] text-sage-deep mb-3">{item.sector}</p>
                <h2 className="font-serif text-3xl sm:text-4xl font-semibold leading-tight">{item.title}</h2>
                <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-muted2 mt-3">{item.clients}</p>
                <p className="mt-5 text-muted2 leading-relaxed">{item.desc}</p>
                <div className="mt-8 flex gap-10">
                  {item.stats.map((s) => (
                    <div key={s.v}>
                      <p className="font-serif text-3xl font-semibold text-periwinkle-deep">{s.k}</p>
                      <p className="text-xs text-muted2 mt-1">{s.v}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </section>
      <CtaBand />
    </>
  );
}
